import { useHistory } from "react-router-dom";
import { Alert } from "react-bootstrap";
import { Helmet } from "react-helmet-async";
import CancelModal from "../../../../../components/cancel-modal/cancel-modal";
import ConfirmationModal from "../../../../../components/confirmation-modal/confirmation-modal";
import TemplateHeaderNew from "../../../../../components/TemplateHeader/TemplateHeaderNew";
import TemplateTaskCreatePanelNew from "../template-task-panels/template-task-create-panel-new";
import PropTypes from "prop-types";

const TemplateTaskCreationTopNew = ({
  isEdit,
  templateName,
  templateId,
  isSubtask,
  alertConfig,
  setAlertConfig,
  isView,
  panelVisibility,
  setPanelVisibility,
  AddAnotherTask
}) => {
  const history = useHistory();

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>
          {!isEdit
            ? "TRIYO · " + templateName
            : isSubtask
            ? "TRIYO · Create Subtask for Project Template"
            : "TRIYO · Create Task for Project Template"}
        </title>
      </Helmet>

      {panelVisibility.showCreatePanel && (
        <TemplateTaskCreatePanelNew
          show={panelVisibility.showCreatePanel}
          isSubtask={isSubtask}
          templateId={templateId}
          templateName={templateName}
          AddAnotherTask={AddAnotherTask}
        />
      )}

      {panelVisibility.showCancelPanel && (
        <CancelModal
          show={panelVisibility.showCancelPanel}
          onHide={() => {
            setPanelVisibility((prev) => ({ ...prev, showCancelPanel: false }));
          }}
          redirectURL={"/admin?tab=templates"}
        />
      )}

      {panelVisibility.showConfirmPanel && (
        <ConfirmationModal
          show={panelVisibility.showConfirmPanel}
          onHide={() => {
            history.push("/admin?tab=groups");
          }}
          redirectURL={"/admin?tab=templates"}
        />
      )}

      {alertConfig.showAlert && (
        <Alert
          show={alertConfig.showAlert}
          onClose={() =>
            setAlertConfig((prevState) => ({
              ...prevState,
              showAlert: false,
            }))
          }
          variant="danger"
          dismissible
        >
          <Alert.Heading>
            {isEdit
              ? "Unable to Edit Task for Project Template!"
              : "Unable to Create Task for Project Template!"}
          </Alert.Heading>
          <p>{alertConfig.alertMessage}</p>
          <hr />
          <div className="d-flex justify-content-end"></div>
        </Alert>
      )}

      <TemplateHeaderNew
        heading="Project Template"
        subHeading={
          isView
            ? "View Task"
            : isSubtask
            ? isEdit
              ? "Edit Subtask"
              : "Create Subtask"
            : isEdit
            ? "Edit Task"
            : "Create Task"
        }
        onClose={() => {
          setPanelVisibility((prev) => ({ ...prev, showCancelPanel: true }));
        }}
      />
    </>
  );
};

TemplateTaskCreationTopNew.propTypes = {
  isEdit: PropTypes.bool,
  templateName: PropTypes.string,
  templateId: PropTypes.number,
  isSubtask: PropTypes.bool,
  alertConfig: PropTypes.object,
  setAlertConfig: PropTypes.func,
  isView: PropTypes.bool,
  panelVisibility: PropTypes.object,
  setPanelVisibility: PropTypes.func,
  AddAnotherTask: PropTypes.func
};
export default TemplateTaskCreationTopNew;